import React, { useEffect } from 'react';
import { useStore } from 'react-redux';
import { setupAuditInterceptor } from '@britishcouncil/react-common';
import {
  include401Interceptor,
  includeAuthInterceptor,
  OidcContext,
} from '@britishcouncil/react-oidc-auth';

import { api } from 'api';
import { includeApiValidationErrorInterceptor } from 'core';
import { useAppSettings } from 'settings';

export const Interceptors = ({ children }: { children?: React.ReactNode }) => {
  const store = useStore();
  const { userManagerSettings } = useAppSettings();
  const { signoutRedirect } = OidcContext.useAuth();

  useEffect(() => {
    includeAuthInterceptor(api.instance, undefined, userManagerSettings);
    include401Interceptor(api.instance, signoutRedirect);
    setupAuditInterceptor(api.instance);
    includeApiValidationErrorInterceptor(api.instance);
  }, [signoutRedirect, store, userManagerSettings]);

  return <>{children}</>;
};
